import { useEffect, useState } from "react";
import {
  hasAnalyticsConsent,
  markSessionConsentDismissed,
  setStoredCookieConsent,
  shouldShowCookieBanner,
} from "@/lib/cookie-consent";
import { grantAdStorageConsent, loadAnalytics } from "@/lib/analytics-loader";
import { cn } from "@/lib/utils";

const AUTO_HIDE_MS = 20_000;

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (hasAnalyticsConsent()) {
      loadAnalytics();
      return;
    }

    if (!shouldShowCookieBanner()) return;

    setVisible(true);
    const timer = window.setTimeout(() => {
      markSessionConsentDismissed();
      setVisible(false);
    }, AUTO_HIDE_MS);

    return () => window.clearTimeout(timer);
  }, []);

  const accept = () => {
    setStoredCookieConsent("accepted");
    loadAnalytics();
    grantAdStorageConsent();
    setVisible(false);
  };

  const decline = () => {
    setStoredCookieConsent("declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className={cn(
        "cookie-consent-banner fixed z-[45] max-w-xs rounded-lg border border-border bg-background/95 p-3 shadow-lg backdrop-blur-sm",
      )}
    >
      <p className="text-xs leading-snug text-muted-foreground">
        We use cookies to improve your experience and analyse site traffic.
      </p>
      <div className="mt-2 flex gap-2">
        <button
          type="button"
          onClick={accept}
          className="rounded-full bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground hover:bg-primary/90"
        >
          Accept
        </button>
        <button
          type="button"
          onClick={decline}
          className="rounded-full border border-input bg-background px-3 py-1.5 text-xs font-semibold text-foreground hover:bg-secondary"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
